// Mock data para Raíz Lecturas

export const bookData = {
  title: "Cábala para principiantes: Una guía práctica para el día a día",
  subtitle: "Cómo desarrollar abundancia material y crecimiento espiritual",
  author: "Agustín Mata",
  year: 2026,
  coverImage: "/images/book-cover.png",
  synopsis: "Una guía no dogmática para entender la Cábala como herramienta diaria. Aprendé a equilibrar abundancia material y espiritual a través del Árbol de la Vida. Este libro ofrece un enfoque práctico y accesible para integrar la sabiduría cabalística en tu vida cotidiana, sin necesidad de conocimientos previos.",
  authorBio: "Agustín Mata, emprendedor y estudioso de la Cábala, comparte un mapa práctico para el crecimiento interior. Con años de experiencia integrando espiritualidad y vida práctica, Agustín ofrece una perspectiva única y accesible.",
  testimonial: {
    quote: "Un mapa claro para vivir con más paz y propósito",
    author: "Lector verificado"
  },
  purchaseLinks: {
    amazon: "https://amazon.com/libro-cabala",
    whatsapp: "https://wa.me/542604801102?text=Quiero%20el%20libro%20C%C3%A1bala%20para%20principiantes"
  }
};

export const publisherData = {
  name: "Raíz Lecturas",
  tagline: "Libros que conectan materia y espíritu",
  description: "Raíz Lecturas es una editorial independiente dedicada a publicaciones prácticas sobre conciencia, Cábala y desarrollo personal. Fundada en 2026 por Agustín Mata, nuestro enfoque es simple: libros que integran lo espiritual con lo cotidiano, sin dogmas. Desde San Rafael, Mendoza, Argentina, publicamos para quienes buscan crecer con honestidad.",
  location: "San Rafael, Mendoza, Argentina",
  year: 2026,
  email: "info@raizlecturas.com",
  whatsapp: "542604801102",
  social: {
    instagram: "https://instagram.com/raizlecturas",
    twitter: "https://twitter.com/raizlecturas",
    whatsapp: "https://wa.me/542604801102"
  }
};

export const heroData = {
  backgroundImage: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80",
  title: "Raíz Lecturas",
  subtitle: "Libros que conectan materia y espíritu",
  description: "Descubrí herramientas prácticas para una vida con más conciencia y propósito",
  ctaText: "Explorá nuestro primer libro"
};